import { type GettingInStep } from '@/karehero-app/access/GettingIn';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// The parts of getting in, for the screen select. Ten screens in one list is a
// wall; these are the three things going on in it.
export const GETTING_IN_SECTIONS = [
  { id: 'front', label: 'The front door' },
  { id: 'access', label: 'Proving access' },
  { id: 'in', label: "You're in" },
];

// Every screen of the walk, in the order it is walked.
export const gettingInScenes: Scene<GettingInStep>[] = [
  {
    id: 'intro',
    label: 'Intro',
    kind: 'happy',
    section: 'front',
    initial: 'intro',
  },
  {
    id: 'register',
    label: 'Create account (Kinde)',
    kind: 'happy',
    section: 'front',
    initial: 'register',
  },
  {
    id: 'signin',
    label: 'Sign in instead',
    kind: 'edge',
    section: 'front',
    initial: 'signin',
  },
  {
    id: 'creating',
    label: 'Setting up your account',
    kind: 'happy',
    section: 'front',
    initial: 'creating',
  },
  {
    id: 'access',
    label: 'Welcome and funding',
    kind: 'happy',
    section: 'access',
    initial: 'access',
  },
  {
    id: 'work-email',
    label: 'Work email',
    kind: 'happy',
    section: 'access',
    initial: 'work-email',
  },
  {
    id: 'code',
    label: 'The emailed code',
    kind: 'happy',
    section: 'access',
    initial: 'code',
  },
  {
    id: 'partner-code',
    label: 'Partner code',
    kind: 'happy',
    section: 'access',
    initial: 'partner-code',
  },
  {
    id: 'payroll-id',
    label: 'Payroll ID',
    kind: 'happy',
    section: 'access',
    initial: 'payroll-id',
  },
  {
    id: 'verified',
    label: "You're in",
    kind: 'happy',
    section: 'in',
    initial: 'verified',
  },
];

export const gettingInSceneById = makeSceneLookup(gettingInScenes);
